import Swiper from "swiper";
import {Navigation, EffectFade, Autoplay} from "swiper/modules";
import anime from 'animejs';

export function initTeamValuesSlider() {
    for(const teamValuesSlider of document.querySelectorAll('.teamValueCarousel__slider')) {

        Swiper.use([Autoplay, Navigation, EffectFade]);
        const swiper = new Swiper(teamValuesSlider, {
            grabCursor: false,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            allowTouchMove: false,
            simulateTouch: false,
            keyboard: { enabled: false },
            autoplay: {
              delay: 15000
            },
            speed: 1000,
            navigation: {
                addIcons: false,
                nextEl: teamValuesSlider.closest(".teamValueCarousel").querySelector('.swiper-button-next'),
                prevEl: teamValuesSlider.closest(".teamValueCarousel").querySelector('.swiper-button-prev'),
            },
            on: {
                init: function() {
                    this.previousIndex = this.realIndex;
                    updateMemberPositions(this, 'init');
                },
                slideChange: function() {
                    const direction = this.realIndex > this.previousIndex ||
                                    (this.previousIndex === this.slides.length - 1 && this.realIndex === 0) ? 'forward' : 'backward';
                    this.previousIndex = this.realIndex;
                    updateMemberPositions(this, direction);
                }
            }
        });
    }
}

function updateMemberPositions(swiper, direction = 'forward') {
    const carousel = swiper.el.closest('.teamValueCarousel');
    const members = carousel.querySelectorAll('.teamValueCarousel__members .teamValueCarousel__member');
    const activeIndex = swiper.realIndex;
    const totalMembers = members.length;

    // Positionen im Kreis (in Grad)
    const positions = {
        active: 335,  // 11 Uhr
        1: 210,       // 7 Uhr
        2: 172.5,     // ~8:15 Uhr
        3: 135,       // ~10:30 Uhr
        4: 97.5,      // ~12:45 Uhr
        5: 60         // 2 Uhr
    };

    let radius = 140;

    if(window.innerWidth >= 360){
        radius = 160;
    }

    if(window.innerWidth >= 768){
        radius = 200;
    }

    if(window.innerWidth >= 1024){
        radius = 260;
    }

    if(window.innerWidth >= 1250){
        radius = 290;
    }

    if(window.innerWidth >= 1400){
        radius = 340;
    }

    function angleToPosition(angle) {
        const rad = angle * Math.PI / 180;
        return {
            x: Math.sin(rad) * radius,
            y: -Math.cos(rad) * radius
        };
    }

    function getClockwiseEndAngle(start, target) {
        let end = target;
        while(end <= start) {
            end += 360;
        }
        return end;
    }

    members.forEach((member, index) => {
        const wasActive = member.classList.contains('is-active');
        const oldDataCount = member.getAttribute('data-count');
        member.classList.remove('is-active');

        if(index === activeIndex) {
            // Aktives Element
            member.classList.add('is-active');

            // Von alter Position animieren (bei backward kommt es von Position 5)
            if(wasActive) {
                // War bereits aktiv, keine Animation nötig (bei init)
                const pos = angleToPosition(positions.active);
                member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
            } else if(oldDataCount && oldDataCount !== '0') {
                // Animieren von alter Position zu active
                const startAngle = positions[oldDataCount];
                const endAngle = positions.active;

                anime({
                    targets: { angle: startAngle },
                    angle: endAngle,
                    duration: 1000,
                    easing: 'easeInOutQuad',
                    update: function(anim) {
                        const currentAngle = anim.animatables[0].target.angle;
                        const pos = angleToPosition(currentAngle);
                        member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                    }
                });
            } else {
                // Neu sichtbar (von data-count="0" oder bei init)
                const pos = angleToPosition(positions.active);
                member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
            }
            member.removeAttribute('data-count');
        } else {
            // Nicht aktives Element
            if(direction === 'init') {
                // INIT: Die ersten 5 Members VORWÄRTS vom aktiven bekommen Positionen 1-5
                const offset = (index - activeIndex + totalMembers) % totalMembers;

                if(offset > 0 && offset <= 5) {
                    const dataCount = offset;
                    const targetAngle = positions[dataCount];
                    const pos = angleToPosition(targetAngle);
                    member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                    member.setAttribute('data-count', dataCount.toString());
                } else {
                    member.setAttribute('data-count', '0');
                }
            } else if(direction === 'forward') {
                // FORWARD: active→5, 1→active, 2→1, 3→2, 4→3, 5→4, 0→5 (neuer Member)
                if(wasActive) {
                    const startAngle = positions.active;
                    const endAngle = getClockwiseEndAngle(startAngle, positions[5]);

                    anime({
                        targets: { angle: startAngle },
                        angle: endAngle,
                        duration: 1000,
                        easing: 'easeInOutQuad',
                        update: function(anim) {
                            const currentAngle = anim.animatables[0].target.angle;
                            const pos = angleToPosition(currentAngle);
                            member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                        }
                    });

                    member.setAttribute('data-count', '5');
                } else if(oldDataCount && oldDataCount !== '0') {
                    // Hat bereits eine Position: Position - 1
                    const oldCount = parseInt(oldDataCount);
                    const newCount = oldCount - 1;

                    if(newCount >= 1) {
                        // Rutscht eine Position nach vorne
                        const startAngle = positions[oldCount];
                        const targetAngle = positions[newCount];

                        anime({
                            targets: { angle: startAngle },
                            angle: targetAngle,
                            duration: 1000,
                            easing: 'easeInOutQuad',
                            update: function(anim) {
                                const currentAngle = anim.animatables[0].target.angle;
                                const pos = angleToPosition(currentAngle);
                                member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                            }
                        });
                        member.setAttribute('data-count', newCount.toString());
                    } else {
                        // War Position 1, wird jetzt active (wird oben behandelt)
                        member.setAttribute('data-count', '0');
                    }
                } else {
                    // War nicht sichtbar (data-count="0")
                    // Prüfe ob dieser Member Position 5 werden soll
                    const offset = (index - activeIndex + totalMembers) % totalMembers;

                    if(offset === 5) {
                        // Dieser Member wird zu Position 5
                        const pos = angleToPosition(positions[5]);
                        member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                        member.setAttribute('data-count', '5');
                    } else {
                        // Bleibt unsichtbar
                        member.setAttribute('data-count', '0');
                    }
                }
            } else {
                // BACKWARD: Berechne neue Position basierend auf Offset vom neuen aktiven
                const offset = (index - activeIndex + totalMembers) % totalMembers;

                if(offset > 0 && offset <= 5) {
                    // Dieser Member sollte jetzt sichtbar sein
                    const newDataCount = offset;

                    if(wasActive) {
                        // War aktiv, wird zu Position 1
                        const startAngle = positions.active;
                        const endAngle = positions[1];

                        anime({
                            targets: { angle: startAngle },
                            angle: endAngle,
                            duration: 1000,
                            easing: 'easeInOutQuad',
                            update: function(anim) {
                                const currentAngle = anim.animatables[0].target.angle;
                                const pos = angleToPosition(currentAngle);
                                member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                            }
                        });
                        member.setAttribute('data-count', '1');
                    } else if(oldDataCount && oldDataCount !== '0') {
                        // Hat bereits eine Position, animiere zur neuen
                        const oldCount = parseInt(oldDataCount);
                        const targetAngle = positions[newDataCount];

                        anime({
                            targets: { angle: positions[oldCount] },
                            angle: targetAngle,
                            duration: 1000,
                            easing: 'easeInOutQuad',
                            update: function(anim) {
                                const currentAngle = anim.animatables[0].target.angle;
                                const pos = angleToPosition(currentAngle);
                                member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                            }
                        });
                        member.setAttribute('data-count', newDataCount.toString());
                    } else {
                        // War nicht sichtbar, erscheint direkt an neuer Position
                        const pos = angleToPosition(positions[newDataCount]);
                        member.style.transform = `translate(calc(-50% + ${pos.x}px), calc(-50% + ${pos.y}px))`;
                        member.setAttribute('data-count', newDataCount.toString());
                    }
                } else {
                    // Sollte nicht sichtbar sein
                    member.setAttribute('data-count', '0');
                    if(oldDataCount && oldDataCount !== '0') {
                        // War sichtbar, verschwindet
                        member.style.transform = 'translate(-50%, -50%)';
                    }
                }
            }
        }
    });
}